import Image from "next/image";
import React from "react";
import themes from "../../themes/themes";
import Remote from "../LoaderRemote";
import styles from "./Banner.module.css";
import { useTranslation } from "../../context/TranslationContext";
import BackButton from "../BackButton";

const Banner = ({ ssr, isAppWebView }) => {
  const { forYou } = useTranslation();
  return (
    <>
      {/* Banner */}
      <div className="overflow-hidden">
        <div className="relative">
          {ssr.result.kapak && (
            <Image
              loader={Remote}
              src={ssr.result.kapak + "?l=0"}
              layout={"fill"}
              objectFit={"contain"}
              objectPosition={"right"}
              alt={ssr.result.title}
              priority={1}
            />
          )}
          <div
            className={`text-center container py-8 sm:py-0 relative content-center justify-center flex flex-col sm:min-h-56 bg-gradient-to-b from-transparent ${themes.toBrand7} to-brand-gray-7 pt-12 sm:pt-16`}
          >
            {/* Back Button */}
            <BackButton isAppWebView={isAppWebView} top="top-1" />
            <span className="text-2xl sm:text-[42px] sm:leading-[55px] font-bold">
              {ssr.RoutingTypeId == "ProductCategory" && (
                <span className="text-brand-blue">{forYou} </span>
              )}
              <h1 className={"inline-block " + styles.TextWhiteShadow}>
                {ssr.result.baslik}
              </h1>
            </span>
            <small
              className={
                "text-xs sm:text-15 text-brand-black opacity-50 leading-5 mt-4" +
                styles.TextWhiteShadow
              }
            >
              {ssr.result.kisa_icerik}
            </small>
          </div>
        </div>
      </div>
      {/* Banner */}
    </>
  );
};

export default Banner;
